/* tslint:disable */
/* eslint-disable */
/**
 * RX360-WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RefreshToken
 */
export interface RefreshToken {
    /**
     * 
     * @type {string}
     * @memberof RefreshToken
     */
    accessToken: string;
    /**
     * 
     * @type {string}
     * @memberof RefreshToken
     */
    refreshToken: string;
    /**
     * 
     * @type {number}
     * @memberof RefreshToken
     */
    expiresIn: number;
    /**
     * 
     * @type {string}
     * @memberof RefreshToken
     */
    tokenType: string;
}

/**
 * Check if a given object implements the RefreshToken interface.
 */
export function instanceOfRefreshToken(value: object): boolean {
    if (!('accessToken' in value)) return false;
    if (!('refreshToken' in value)) return false;
    if (!('expiresIn' in value)) return false;
    if (!('tokenType' in value)) return false;
    return true;
}

export function RefreshTokenFromJSON(json: any): RefreshToken {
    return RefreshTokenFromJSONTyped(json, false);
}

export function RefreshTokenFromJSONTyped(json: any, ignoreDiscriminator: boolean): RefreshToken {
    if (json == null) {
        return json;
    }
    return {
        
        'accessToken': json['access_token'],
        'refreshToken': json['refresh_token'],
        'expiresIn': json['expires_in'],
        'tokenType': json['token_type'],
    };
}

export function RefreshTokenToJSON(value?: RefreshToken | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'access_token': value['accessToken'],
        'refresh_token': value['refreshToken'],
        'expires_in': value['expiresIn'],
        'token_type': value['tokenType'],
    };
}

